// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function WebPayments(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'WebPayments',
      'aria-hidden': true,
      focusable: false,
      width: 10 * scale,
      height: 10 * scale,
      viewBox: '0 0 10 10',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.922 5.885a5.03 5.03 0 00-.415-3.053A5.02 5.02 0 005.885.078a5.03 5.03 0 00-3.053.415A5.02 5.02 0 00.078 4.115a5.03 5.03 0 00.415 3.053 5.02 5.02 0 003.622 2.754 5.03 5.03 0 003.053-.415 5.02 5.02 0 002.754-3.622zM5 1c.345 0 .68.044 1 .126V3H4V1.126C4.32 1.044 4.655 1 5 1zM1.535 3A4.02 4.02 0 013 1.535V3H1.535zM1 5c0-.345.044-.68.126-1H3v2H1.126A4.007 4.007 0 011 5zm2 3.465A4.02 4.02 0 011.535 7H3v1.465zM5 9c-.345 0-.68-.044-1-.126V7h2v1.874C5.68 8.956 5.345 9 5 9zm3.465-2A4.02 4.02 0 017 8.465V7h1.465zM9 5c0 .345-.044.68-.126 1H7V4h1.874c.082.32.126.655.126 1zM7 3h1.465A4.02 4.02 0 007 1.535V3zM4 4v2h2V4H4z',
      fill: 'currentColor',
    })
  );
}
